export default "__VITE_ASSET__DyUYeUxH__"